export const TICKERS = [
  "深夜连麦局进行中：揭秘「反差」ID 背后故事，弹幕已刷屏",
  "今日热搜吐槽大会 5.1 万人同时围观，榜一礼物送出「小火箭」",
  "八卦研究所连麦对线：网友现场爆料，主播当场求证",
  "本周人气主播「星野LIVE」音乐PK开赛，打赏榜实时更新",
  "新主播快速起号指南开讲，麦位已满，围观有回放",
  "弹幕「懂王」竞猜上线，猜中瓜前五名瓜友瓜分礼物",
];

export const LIVE_ROOMS = [
  {
    id: 1,
    title: "深夜情感树洞 · 匿名连麦",
    host: "柚子电台",
    viewers: "2.3万",
    gifts: "1.2万",
    tag: "情感",
    badge: "连麦",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20dim%20warm%20toned%20late%20night%20podcast%20studio%20with%20professional%20broadcast%20microphone%20and%20amber%20string%20lights%20and%20soft%20candle%20glow%2C%20intimate%20talk%20show%20vibe%2C%20cinematic%20warm%20bokeh%2C%20moody%20yet%20inviting%20atmosphere&width=800&height=500&seq=room-1&orientation=landscape",
  },
  {
    id: 2,
    title: "今日热搜吐槽大会",
    host: "吃瓜一姐",
    viewers: "5.1万",
    gifts: "3.4万",
    tag: "热点",
    badge: "爆",
    image:
      "https://readdy.ai/api/search-image?query=energetic%20young%20female%20vlogger%20gesturing%20while%20talking%20on%20a%20vibrant%20warm%20studio%20talk%20show%20set%20with%20neon%20orange%20and%20amber%20backlight%20panels%2C%20lively%20news%20desk%20vibe%2C%20cinematic%20warm%20color%20grade%2C%20high%20energy&width=800&height=500&seq=room-2&orientation=landscape",
  },
  {
    id: 3,
    title: "八卦研究所 · 连麦对线",
    host: "瓜田小明",
    viewers: "3.8万",
    gifts: "2.1万",
    tag: "八卦",
    badge: "对线",
    image:
      "https://readdy.ai/api/search-image?query=two%20conversation%20partners%20talking%20head%20style%20in%20split%20frame%20warm%20orange%20studio%2C%20gossip%20investigation%20podcast%20desk%20with%20coffee%20cups%2C%20amber%20and%20coral%20cinematic%20lighting%2C%20curious%20and%20playful%20mood&width=800&height=500&seq=room-3&orientation=landscape",
  },
  {
    id: 4,
    title: "萌宠治愈现场 · 在线吸猫",
    host: "阿橘的日常",
    viewers: "1.6万",
    gifts: "6800",
    tag: "萌宠",
    badge: "治愈",
    image:
      "https://readdy.ai/api/search-image?query=adorable%20ginger%20orange%20cat%20lying%20on%20a%20soft%20knitted%20blanket%20under%20warm%20ring%20light%20in%20a%20cozy%20home%20room%2C%20golden%20hour%20warm%20tone%2C%20soft%20natural%20light%2C%20comforting%20and%20calm%20atmosphere%2C%20high%20detail&width=800&height=500&seq=room-4&orientation=landscape",
  },
  {
    id: 5,
    title: "音乐PK大赛 · 打赏榜实时",
    host: "星野LIVE",
    viewers: "4.5万",
    gifts: "5.8万",
    tag: "音乐",
    badge: "PK",
    image:
      "https://readdy.ai/api/search-image?query=young%20singer%20performing%20into%20microphone%20on%20a%20warm%20amber%20stage%20with%20tangerine%20and%20gold%20spotlight%20bokeh%20and%20concert%20lights%2C%20dreamy%20warm%20cinematic%20grade%2C%20passionate%20performance%20mood&width=800&height=500&seq=room-5&orientation=landscape",
  },
  {
    id: 6,
    title: "职场故事局 · 弹幕互动",
    host: "大厂老K",
    viewers: "2.9万",
    gifts: "1.5万",
    tag: "职场",
    badge: "回放",
    image:
      "https://readdy.ai/api/search-image?query=casual%20business%20talk%20studio%20scene%20with%20a%20warm%20wooden%20desk%20and%20laptop%20and%20coffee%2C%20mentor%20sharing%20career%20stories%2C%20amber%20and%20honey%20tones%2C%20relaxed%20warm%20lighting%2C%20approachable%20podcast%20atmosphere&width=800&height=500&seq=room-6&orientation=landscape",
  },
];

export const FEATURES = [
  {
    icon: "ri-video-chat-line",
    title: "高清连麦上麦",
    desc: "一秒开麦接入现场，和主播面对面聊，匿名与露脸自由切换，随时成为瓜圈主角。",
  },
  {
    icon: "ri-chat-3-line",
    title: "实时弹幕刷屏",
    desc: "弹幕不限速、表情包齐飞，你的一句话可能被主播当场翻牌，现场感直接拉满。",
  },
  {
    icon: "ri-gift-2-line",
    title: "礼物打赏互动",
    desc: "小火箭、爱心城堡、锦鲤大奖花式礼物齐上阵，榜单一出谁是全场最靓的仔一目了然。",
  },
  {
    icon: "ri-play-circle-line",
    title: "精彩回放补课",
    desc: "错过现场也不慌，精彩片段与整场回放随时可看，爆点切片一键分享给瓜友。",
  },
  {
    icon: "ri-fire-line",
    title: "吃瓜热榜速递",
    desc: "热搜瓜、口碑局、话题榜实时更新，哪里热闹点哪里，永远不吃过期瓜。",
  },
  {
    icon: "ri-shield-check-line",
    title: "清朗互动守护",
    desc: "实时内容审核 + 一键举报，违禁言论与骚扰零容忍，让每一场吃瓜都安心尽兴。",
  },
];

export const RANKING_TABS = ["实时热度", "本周口碑"];

export const RANKINGS = {
  实时热度: [
    { rank: 1, topic: "「合租室友」深夜连麦互爆，围观 8.6 万人", host: "柚子电台", heat: 86.2, trend: "up", tag: "情感" },
    { rank: 2, topic: "热搜第一位瓜：主播现场连线当事人求证", host: "吃瓜一姐", heat: 79.4, trend: "up", tag: "热点" },
    { rank: 3, topic: "网友晒聊天记录，弹幕当场变身「侦探局」", host: "瓜田小明", heat: 71.8, trend: "up", tag: "八卦" },
    { rank: 4, topic: "裁员传闻实锤？职场博主在线普法拆解", host: "大厂老K", heat: 63.5, trend: "down", tag: "职场" },
    { rank: 5, topic: "新歌首发连麦首唱，礼物雨下到看不清弹幕", host: "星野LIVE", heat: 58.9, trend: "up", tag: "音乐" },
    { rank: 6, topic: "猫界顶流「阿橘」今天又翻车名场面", host: "阿橘的日常", heat: 52.3, trend: "down", tag: "萌宠" },
  ],
  本周口碑: [
    { rank: 1, topic: "「吃瓜第一课」新手快速起号连麦教程", host: "吃瓜一姐", heat: 92.1, trend: "up", tag: "教程" },
    { rank: 2, topic: "全网最全「匿名爆料」上麦守则科普", host: "瓜田小明", heat: 85.6, trend: "up", tag: "科普" },
    { rank: 3, topic: "打工人下班治愈局：报菜名式吐槽减压", host: "柚子电台", heat: 78.8, trend: "up", tag: "情感" },
    { rank: 4, topic: "年度锦鲤大奖回放：一把连麦薅到万元礼物", host: "星野LIVE", heat: 70.2, trend: "up", tag: "娱乐" },
    { rank: 5, topic: "萌宠治愈整周精选：阿橘名场面合集", host: "阿橘的日常", heat: 64.9, trend: "down", tag: "萌宠" },
    { rank: 6, topic: "简历怎么写才不踩雷？大厂 HR 在线答疑", host: "大厂老K", heat: 59.7, trend: "up", tag: "职场" },
  ],
};

export const HOSTS = [
  {
    name: "吃瓜一姐",
    desc: "热搜雷达，敢说敢聊，翻牌率超高的人气麦主",
    followers: "128万",
    style: "吐槽",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20cheerful%20young%20asian%20female%20streamer%20smiling%20with%20headset%2C%20warm%20coral%20and%20amber%20studio%20lighting%20background%2C%20friendly%20confident%20expression%2C%20bright%20and%20clean%20composition&width=320&height=320&seq=host-1&orientation=squarish",
  },
  {
    name: "瓜田小明",
    desc: "八卦研究所所长，资料党的究极体，专查反转",
    followers: "86万",
    style: "对线",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20playful%20young%20asian%20male%20streamer%20wearing%20headset%20and%20grinning%2C%20warm%20orange%20neon%20studio%20background%2C%20curious%20and%20witty%20expression%2C%20vibrant%20clean%20portrait&width=320&height=320&seq=host-2&orientation=squarish",
  },
  {
    name: "星野LIVE",
    desc: "麦上开唱的音乐现场，礼物点亮全场的高能歌手",
    followers: "210万",
    style: "音乐",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20stylish%20young%20asian%20female%20singer%20with%20headphones%20and%20warm%20golden%20stage%20spotlight%20bokeh%20background%2C%20confident%20artistic%20vibe%2C%20cinematic%20warm%20portrait%20lighting&width=320&height=320&seq=host-3&orientation=squarish",
  },
  {
    name: "大厂老K",
    desc: "职场避坑引路人，边吃瓜边教你懂规则",
    followers: "45万",
    style: "职场",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20of%20a%20friendly%20professional%20asian%20male%20mentor%20in%20smart%20casual%20shirt%20with%20warm%20honey%20toned%20office%20lighting%2C%20approachable%20smile%2C%20clean%20warm%20portrait%20composition&width=320&height=320&seq=host-4&orientation=squarish",
  },
];

export const STEPS = [
  {
    icon: "ri-macbook-line",
    step: "01",
    title: "进入现场",
    desc: "网页一键开播即进，无需下载。首页挑选你感兴趣的直播间，或直接搜「吃瓜快手」。",
  },
  {
    icon: "ri-discuss-line",
    step: "02",
    title: "发弹幕上麦",
    desc: "弹幕先来一波互动，想开口就点击申请连麦，排队上麦，和主播当面聊聊你的瓜。",
  },
  {
    icon: "ri-gift-2-line",
    step: "03",
    title: "刷礼物上榜",
    desc: "为喜欢的主播刷一波礼物，热度一冲上榜，整场节奏由你带，还能抽锦鲤大奖。",
  },
];

export const REVIEWS = [
  {
    name: "小鹿乱撞",
    role: "资深瓜友",
    text: "每天睡前必逛一姐的场，弹幕比综艺还精彩，上次随手留言居然被翻牌了，第一次体验当主角的感觉！",
    stars: 5,
  },
  {
    name: "北漂老王",
    role: "匿名连麦er",
    text: "匿名上麦真的缓解了我社恐，职场那期我鼓起勇气问了跳槽问题，大厂老K 回答特别实在，回放反复看了三遍。",
    stars: 5,
  },
  {
    name: "奶盖不加糖",
    role: "新晋主播",
    text: "作为刚开播的新人，平台对萌新特别友好，教程回放齐全，氛围也清朗，弹幕都是讲道理的真瓜友。",
    stars: 4,
  },
];

export const FAQS = [
  {
    q: "「吃瓜快手」需要下载 App 吗？怎么开始围观？",
    a: "不需要下载任何客户端。在浏览器打开吃瓜快手即可直接进入直播间，网页端与移动端体验一致。想围观热点、发弹幕、连麦互动或看回放，从首页任意一场正在热播的直播间点进去就能开始，全程即点即用。",
  },
  {
    q: "如何申请连麦、和主播面对面聊天？",
    a: "进入直播间后，点击画面下方或侧边的「申请连麦」按钮排队即可。主播通过后，你可以选择露脸或仅语音连麦，也可以保持匿名身份。部分情感、职场主题的连麦局还支持「匿名变声」上麦，方便你更自在地说出自己的故事。",
  },
  {
    q: "弹幕、打赏和礼物具体怎么玩？",
    a: "弹幕在观看界面输入框发送即可实时滚动上屏；礼物分为小爱心、啤酒、小火箭、城堡等多种，点击礼物栏选择送出即可为你喜欢的主播增加互动热度。每日签到与观看时长还会累计积分，积分可兑换限定弹幕特效与回放券。",
  },
  {
    q: "错过了正在热播的现场，还能看重播吗？",
    a: "当然可以。大部分直播间会自动生成整场精彩回放，热门爆点还会被切片成短视频，方便你快速补课。你可以在直播间的「回放」标签，或首页的「本周口碑」榜单里按热度查找感兴趣的完整回放。",
  },
  {
    q: "想成为吃瓜快手主播，有哪些要求？",
    a: "我们欢迎每一位有表达欲、想被听见的朋友开播。只要年满规定年龄、愿意遵守平台内容与社区规范，即可申请开播。平台会为新主播提供起号教程回放、流量扶持与反作弊保护，陪伴你从第一场连麦逐步成长。",
  },
  {
    q: "平台如何保障弹幕与连麦内容安全？",
    a: "吃瓜快手内置实时内容审核与分级处理机制，对违规言论、恶意骚扰实行零容忍；每位用户都可通过「举报」一键提交问题，我们会在收到反馈后尽快核查处理。营造清朗、健康、友善的吃瓜氛围，是平台和每一位瓜友共同的责任。",
  },
];